import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-giftCards",
  "use": "icon-giftCards-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-giftCards\"><path d=\"M881.70666667 316.8H144.32c-40.74666667 0-73.70666667 32.85333333-73.70666667 73.28v147.94666667h884.8V390.08c0.10666667-40.42666667-32.96-73.28-73.70666666-73.28zM70.61333333 882.13333333c0 40.74666667 33.06666667 73.81333333 73.70666667 73.81333334h737.38666667c40.74666667 0 73.81333333-33.06666667 73.81333333-73.81333334V611.52H70.61333333V882.13333333z m639.36-791.78666666c-10.45333333-18.88-33.49333333-25.28-51.52-14.4L341.01333333 267.62666667h466.88l-97.92-177.28z\" p-id=\"1303\" fill=\"#ffffff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/giftCards.svg
// module id = JX/W
// module chunks = 112